import { configureStore } from '@reduxjs/toolkit'

import createReducer from './rootReducer'

const middlewares = []

if (process.env.NODE_ENV === 'development') {
  const { logger } = require(`redux-logger`)

  middlewares.push(logger)
}

const store = configureStore({
  reducer: createReducer(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
    }).concat(middlewares),
  devTools: process.env.NODE_ENV === 'development',
})

store.asyncRedusers = {}

export default store
